<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-btn class="mr-2" depressed small color="success" @click.stop="csvDownloadDialogOpen">CSVダウンロード</v-btn>
                <v-btn v-if="updatePermission" class="mr-2" depressed small color="success" :to="{ name: 'WorkerDailyReportComform' }" >作業日報確認</v-btn>
            </v-col>
        </v-row>
        <v-row no-gutters>
             <v-col cols="12">
                 <v-card>
                     <v-tabs v-model="statusTab" background-color="accent" dark>
                         <v-tab v-for="item in statusItems" :key="item.status">
                             {{ item.content }}
                         </v-tab>
                     </v-tabs>
                     <v-tabs-items v-model="statusTab">
                         <v-tab-item v-for="item in statusItems" :key="item.status">
                             <v-card>
                                <v-card-text>
                                    <v-row no-gutters>
                                        <v-col cols="4">
                                            <v-select
                                                v-model="item.select"
                                                :items="item.list"
                                                item-text="construction_name"
                                                item-value="construction_id"
                                                label="工事情報"
                                                no-data-text="データがありません"
                                                return-object
                                                dense
                                                outlined
                                                @change="constructionSerect"/>
                                        </v-col>
                                        <v-spacer/>
                                        <v-btn v-if="item.status == statuses.received.value" depressed small @click.stop="stored" color="success">新規作成</v-btn>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <custom-data-table
                                                tableName="工事情報"
                                                :header="headers"
                                                :items="item.data"
                                                :loading="loading"
                                                :visibleTop="false">
                                                <template v-slot:action="{ item }">
                                                    <v-btn v-if="updatePermission" class="mr-2" depressed small color="warning" :to="{ name: 'ConstructionDailyReportEdit', params: { date: item.worker_date, id: item.construction_id, number: item.construction_number, name: item.construction_name } }">再集計</v-btn>
                                                    <v-btn class="mr-2" depressed small color="info" :to="{ name: 'ConstructionDailyReportInfo', params: { date: item.worker_date, id: item.construction_id, number: item.construction_number, name: item.construction_name } }">閲覧</v-btn>
                                                    <v-btn class="mr-2" depressed small color="success" @click.prevent="download(item.construction_id, item.worker_date)">データ出力</v-btn>
                                                </template>
                                            </custom-data-table>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                             </v-card>
                         </v-tab-item>
                     </v-tabs-items>
                 </v-card>
             </v-col>
        </v-row>
        <v-row justify="center">
            <v-dialog v-model="reportDateDialogDrawer" persistent max-width="500">
                <v-card>
                    <v-container>
                        <v-card-text>
                            <v-row justify="center">
                                <v-date-picker v-model="workerDate" :max="today" :allowed-dates="allowedDates" @change="stored" locale="ja_jp"></v-date-picker>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn depressed @click.stop="reportDateDialogDrawer=!reportDateDialogDrawer" color="grey lighten-1">キャンセル</v-btn>
                            <v-btn depressed @click.stop="create" color="success" :disabled="reportDateDisabled">作成</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card>
            </v-dialog>
            <v-dialog v-model="workReportCheckDialogDrawer" persistent max-width="500">
                <v-card>
                    <v-container>
                        <v-card-text>
                            <v-form ref="excel_input_form" v-model="excelInputValid" @submit.prevent>
                                <v-row>
                                    <v-menu
                                        v-model="month_input_menu"
                                        transition="scale-transition"
                                        min-width="290px"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="month"
                                                label="処理年月"
                                                v-bind="attrs"
                                                v-on="on"
                                                :rules="processDateRules"
                                                readonly
                                                outlined
                                                dense
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="month"
                                            type="month"
                                            :max="today"
                                            no-title
                                            scrollable
                                            actions
                                            locale="ja-jp"
                                            :close-on-content-click="true"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-row>
                                <v-row>
                                    <v-radio-group
                                        v-model="type"
                                        row
                                    >
                                        <v-radio
                                            label="日毎"
                                            :value="outputType.date"
                                        ></v-radio>
                                        <v-radio
                                            label="個人毎"
                                            :value="outputType.person"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-row>
                            </v-form>
                            <v-divider/>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn depressed @click.stop="workReportCheckDialogDrawer=!workReportCheckDialogDrawer" color="grey lighten-1">キャンセル</v-btn>
                            <v-btn depressed @click.stop="csvDownload" color="success" :disabled="!excelInputValid"><v-icon class="mr-1">mdi-file-download</v-icon>ダウンロード</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import Rule from "@/validation/rules";
  import CustomDataTable from "@/components/custom_ui/CustomDataTable";
  import ConstructionRefineApi from "@/api/construction-refine-api";
  import ConstructionDailyReportApi from "@/api/construction-daily-report-api";
  import ReportExcelApi from "@/api/report-excel-api";
  import DateEveryExcelApi from "@/api/date-every-excel-api";
  import PersonEveryExcelApi from "@/api/person-every-excel-api";
  import { saveAs } from 'file-saver';
  export default {
    name: "ConstructionDailyReport",
    components: {
      CustomDataTable
    },
    props: ["user"],
    data: () => ({
        // 作業日報一覧テーブル
        loading: false,
        statuses: {
            notReceived: { name: "未受注", value: 0 },
            received: { name: "受注済", value: 1 },
            missing: { name: "失注済", value: 2 },
            reflect: { name: "実績反映済", value: 3 }
        },
        returnConstructionNumber: null,

        // 工事日報ステータスタブ
        statusTab: null,
        statusItems: [],

        // 工事日報データ
        constructionDailys: [],

        // 新規作成ダイアログ
        reportDateDialogDrawer: false,
        reportDateDisabled: false,
        workerDate: new Date().toISOString().substr(0,10),
        today: new Date().toISOString().substr(0,10),

        // テーブル
        headers: [
            { text: "日付", value: "worker_date" },
            { text: "アクション", value: "action" }
        ],

        // 作業日報確認CSVダウンロードダイアログ
        excelInputValid: false,
        processDateRules: Rule.processDateRules,
        workReportCheckDialogDrawer: false,
        outputType: {
            date: 'date_every',
            person: 'person_every'
        },
        type: 'date_every',
        month_input_menu: false,
        month: null,

        // 権限
        updatePermission: true,
        displayPermission: false
    }),
    created() {
        this.initialize();
    },
    methods: {
        isLoading() {
            this.loading = !this.loading;
            this.$emit("loading", this.loading);
        },
        // 初期化処理
        initialize() {
            this.isLoading();
            if (this.user.role_id == 0) {
                this.updatePermission = this.user.permission_config.CTSG00013.update;
                this.displayPermission = this.user.permission_config.CTSG00013.display;
            }
            this.returnConstructionNumber = this.$route.params.number;
            this.reportExcelApi = new ReportExcelApi();
            this.dateEveryExcelApi = new DateEveryExcelApi();
            this.personEveryExcelApi = new PersonEveryExcelApi();
            this.constructionRefineApi = new ConstructionRefineApi();
            this.constructionDailyReportApi = new ConstructionDailyReportApi();
            var promise = this.constructionDailyReportApi.list();
            if (this.displayPermission) {
                promise = this.constructionDailyReportApi.all();
            }
            promise.then((response) => {
                for(var report of response.data.body.construction_daily_report_list){
                    if (!(report.construction_number in this.constructionDailys)) {
                        this.constructionDailys[report.construction_number] = [];
                    }
                    this.constructionDailys[report.construction_number].push(report);
                }
                var receivedList = [];
                var reflectList = [];
                for(var construction of response.data.body.construction_info) {
                    var item = {
                        construction_id: construction.construction_id,
                        construction_number: construction.construction_number,
                        construction_name: construction.construction_number + ' ' + construction.construction_name,
                        status: construction.status
                    };

                    // 受注済
                    if (construction.status == this.statuses.received.value) {
                        receivedList.push(item)
                    }
                    // 実績反映済
                    else if (construction.status == this.statuses.reflect.value) {
                        reflectList.push(item)
                    }
                }
                // タブ設定
                var selectReceivedItem = receivedList.length > 0 ? receivedList[0] : null;
                if (this.returnConstructionNumber && receivedList.length > 0 && receivedList.some(x => x.construction_number === this.returnConstructionNumber)) {
                    selectReceivedItem = receivedList.find(x => x.construction_number === this.returnConstructionNumber);
                }
                this.statusItems.push(
                    {
                        status: this.statuses.received.value,
                        content: this.statuses.received.name,
                        list: receivedList,
                        select: selectReceivedItem,
                        data: [],
                        dates: []
                    }
                )
                this.constructionSerect(selectReceivedItem);

                var selectReflectItem = reflectList.length > 0 ? reflectList[0] : null
                if (this.returnConstructionNumber && reflectList.length > 0 && reflectList.some(x => x.construction_number === this.returnConstructionNumber)) {
                    selectReflectItem = reflectList.find(x => x.construction_number === this.returnConstructionNumber);
                }
                this.statusItems.push(
                    {
                        status: this.statuses.reflect.value,
                        content: this.statuses.reflect.name,
                        list: reflectList,
                        select: selectReflectItem,
                        data: [],
                        dates: []
                    }
                )
                this.constructionSerect(selectReflectItem);
            }).catch(error => {
                useAppInsights().trackException({exception: error});
                if (error.response) {
                  if (error.response.data.status == statusList.status.authError) {
                    this.$emit('logoutConform');
                  } else if (error.response.data.status == statusList.status.entityError) {
                    this.$emit("error",error.response.data.message);
                    this.$router.push({ name: "Dashboard" })
                  } else {
                    this.$emit("error",error.response.data.message);
                  }
                } else {
                  this.$emit("error","サーバーエラーが発生しました。");
                }
            }).finally(() => {
                this.isLoading();
            });
        },
        constructionSerect(item) {
            if (item != null && this.statusItems.some(x => x.status === item.status)) {
                this.statusItems.find(x => x.status === item.status).dates = []
                this.statusItems.find(x => x.status === item.status).data = []
                if (item.construction_number in this.constructionDailys) {
                    for (var report of this.constructionDailys[item.construction_number]) {
                        this.statusItems.find(x => x.status === item.status).dates.push(this.parseDate(report.worker_date));
                        this.statusItems.find(x => x.status === item.status).data.push(report);
                    }
                }
            }
        },
        allowedDates (val) {
            return this.statusItems[this.statusTab].dates.indexOf(val) === -1
        },
        changeConstruction () {
            this.reportDateDisabled =  this.allowedDates(this.workerDate) && (this.constructionNumber === null);
        },
        stored() {
            this.reportDateDialogDrawer = true;
        },
        create() {
            var item = this.statusItems[this.statusTab].select;
            this.$router.push({ name: 'ConstructionDailyReportStore', params: {
                id : item.construction_id,
                date: this.workerDate,
                number: item.construction_number,
                name: item.construction_name
            }});
        },
        //日付フォーマット
        parseDate (date) {
            if (!date) return null;
            const [year,month, day] = date.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        },
        // データ出力
        download(id, date) {
            this.isLoading();
            const promise = this.reportExcelApi.download(id, this.parseDate(date));
            promise.then((response) => {
                saveAs(response.data.body.url, response.data.body.filename);
                this.$emit('success', response.data.message);
            }).catch(error => {
                useAppInsights().trackException({exception: error});
                if(error.response){
                    this.$emit("error",error.response.data.message);
                }else{
                    this.$emit("error","サーバーエラーが発生しました");
                }
            }).finally(() => {
                this.isLoading();
            })
        },
        csvDownloadDialogOpen() {
            if (this.$refs.excel_input_form != null) {
                this.$refs.excel_input_form.resetValidation();
            }
            this.workReportCheckDialogDrawer = true
        },
        csvDownload() {
            // 日毎
            if (this.type == this.outputType.date) {
                this.isLoading();
                const promise = this.dateEveryExcelApi.download(this.month);
                promise.then((response) => {
                    if (response.data.body) {
                        saveAs(response.data.body.url, response.data.body.filename);
                    }
                    this.$emit('success', response.data.message);
                }).catch(error => {
                    useAppInsights().trackException({exception: error});
                    if(error.response){
                        this.$emit("error",error.response.data.message);
                    }else{
                        this.$emit("error","サーバーエラーが発生しました");
                    }
                }).finally(() => {
                    this.isLoading();
                });
            // 個人毎
            } else {
                this.isLoading();
                const promise = this.personEveryExcelApi.download(this.month);
                promise.then((response) => {
                    if (response.data.body) {
                        saveAs(response.data.body.url, response.data.body.filename);
                    }
                    this.$emit('success', response.data.message);
                }).catch(error => {
                    useAppInsights().trackException({exception: error});
                    if(error.response){
                        this.$emit("error",error.response.data.message);
                    }else{
                        this.$emit("error","サーバーエラーが発生しました");
                    }
                }).finally(() => {
                    this.isLoading();
                });
            }
            this.month = null
            this.workReportCheckDialogDrawer = false
        }
    }
  };
</script>
